import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const Filter = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 2H5C4.20462 2.00087 3.44206 2.31722 2.87964 2.87964C2.31722 3.44206 2.00087 4.20462 2 5V6.17188C2.00092 6.58527 2.08768 6.99396 2.25476 7.37207C2.26331 7.39331 2.27643 7.41064 2.28638 7.43115C2.43174 7.75099 2.63232 8.04272 2.87891 8.29297L9 14.4141V21C9.00004 21.1705 9.04363 21.3381 9.12665 21.4869C9.20966 21.6358 9.32935 21.761 9.47434 21.8506C9.61933 21.9402 9.78482 21.9913 9.9551 21.999C10.1254 22.0067 10.2948 21.9707 10.4473 21.8945L14.4473 19.8945C14.6134 19.8114 14.753 19.6837 14.8506 19.5257C14.9483 19.3678 15 19.1857 15 19V14.4141L21.1211 8.293C21.3675 8.04288 21.568 7.75132 21.7134 7.43167C21.7235 7.41092 21.7368 7.39334 21.7454 7.37186C21.9124 6.99381 21.9991 6.58519 22 6.17188V5C21.9991 4.20462 21.6828 3.44206 21.1204 2.87964C20.5579 2.31722 19.7954 2.00087 19 2ZM20 6H4V5C4.00018 4.73484 4.10559 4.48059 4.29309 4.29309C4.48059 4.10559 4.73484 4.00018 5 4H19C19.2652 4.00018 19.5194 4.10559 19.7069 4.29309C19.8944 4.48059 19.9998 4.73484 20 5V6Z"
      fill="currentColor"
    />
  </svg>
)

export default Filter
